define('modules/common/service/DocumentiFascicolo',[], function() {
    var DocumentiFascicolo = function($http, $q, PATH, Token, Studio, LoadingHandler) {

        var dati = false;

        var count = function(hrefDocumenti) {
            return load(hrefDocumenti)
                .then(function(documenti) {
                    return documenti.length;
                }, function(error) {
                    if (error.status === 404) {
                        return 0;
                    } else {
                        console.log(error.status);
                    }
                });
        };

        var load = function(hrefDocumenti) {

            LoadingHandler.start();
            $http.defaults.headers.common['Authorization'] = 'TOKEN:' + Token.get();
            var deferred = $q.defer();

            Studio.getId().then(function(id) {
                $http({
                    method: 'GET',
                    url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/' + hrefDocumenti,
                    cache: false
                }).then(
                    function(response) {
                        dati = response.data.documenti;
                        deferred.resolve(response.data.documenti);
                        LoadingHandler.stop();
                    },
                    function(error) {
                        deferred.reject({
                            status: error.status,
                            data: error.data
                        });
                        LoadingHandler.stop();
                    });
            }, function(error) {
                deferred.reject({
                    status: error.status,
                    data: error.data
                });
                LoadingHandler.stop();
            });

            return deferred.promise;
        };

        var loadCartelle = function(hrefDocumenti,idCartella) {
            
                        LoadingHandler.start();
                        $http.defaults.headers.common['Authorization'] = 'TOKEN:' + Token.get();
                        var deferred = $q.defer();
            
                        idCartella = idCartella || 0;
                        
            
                        Studio.getId().then(function(id) {
                            $http({
                                method: 'GET',
                                url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/' + hrefDocumenti + '/cartella/' + idCartella,
                                cache: false
                            }).then(
                                function(response) {
                                    dati = response.data.documenti;
                                    deferred.resolve(response.data);
                                    LoadingHandler.stop();
                                },
                                function(error) {
                                    deferred.reject({
                                        status: error.status,
                                        data: error.data
                                    });
                                    LoadingHandler.stop();
                                });
                        }, function(error) {
                            deferred.reject({
                                status: error.status,
                                data: error.data
                            });
                            LoadingHandler.stop();
                        });
            
                        return deferred.promise;
                    };

        return {
            load: load,
            loadCartelle: loadCartelle,
            count: count
        };
    };

    return ["$http", "$q", "PATH", "Token", "Studio", "LoadingHandler", DocumentiFascicolo];
});
